export { baseStates } from '@/stores/base/states';
export { baseActions } from '@/stores/base/actions';
export { baseMutations } from '@/stores/base/mutations';
export { baseGetters } from '@/stores/base/getters';



// WEBPACK FOOTER //
// ./src/stores/base/index.js